import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'

import App from './App'
import router from './router'
import store from './store'
import i18n from './i18n';
import ElementLocale from 'element-ui/lib/locale';
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css';
import './assets/font-family/fonts.css';

Vue.http = Vue.prototype.$http = axios

Vue.config.productionTip = false
Vue.config.transpileDependencies = [
  'resize-detector'
]

Vue.use(ElementUI);
Vue.use(VXETable);
VXETable.setup({
  i18n: (key, args) => {
    const messages = {
      'vxe.table.confirmFilter': 'comfirm',
      'vxe.table.resetFilter': 'reset',
      'vxe.table.emptyText': 'empty text'
    };
    return messages[key] || key;
  },
});
// Vue.directive(loadmore.name, loadmore.componentUpdated);
// 组件多语言
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
});

ElementLocale.i18n((key, value) => i18n.t(key, value))

/* eslint-disable no-new */
new Vue({
  components: {App},
  router,
  store,
  i18n,
  template: '<App/>'
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js